import ClassItem from '@/models/interfaces/ClassItem';
import ClassItemRate from '@/models/interfaces/ClassItemRate';
import { ClassRatingLike } from '@/utils/ClassRatingLike';
import { Type as IndicatorsType } from '@solucx/indicators';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ClassCES extends Vue {
  @Prop({ required: true })
  public readonly item!: ClassItem;

  @Prop({ required: true, type: Object, default: () => ({}) })
  public readonly value!: ClassItemRate;

  public updateLike(score: number) {
    this.value.like = ClassRatingLike.getRatingLike(score, IndicatorsType.CES);
    this.$emit('input', this.value);
  }
}
